<template>
  <SysDialogFullscreen v-model="DIALOG_ATIVO_COMPUTED">
    <template #titulo>
      <div class="d-flex align-center w-full">
        <v-btn icon class="ml-n2 mr-5" dark @click="DIALOG_ATIVO_COMPUTED = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>

        <div class="d-flex align-center">
          <span>Detalhamento</span>

          <v-divider vertical dark class="mx-2" />

          <div class="font-13">
            {{ filtros.nivel_servico ? map_niveis_servico[filtros.nivel_servico] : '6. Total Geral' }}
            <v-icon dark small>mdi-chevron-right</v-icon>
            {{ `${nomeMeses(filtros.mes - 1)} de ${filtros.ano}` }}
          </div>
        </div>

        <v-spacer />

        <div class="d-flex align-center font-16">
          <span class="mr-1 font-weight-bold">Total rupturas (R$ custo):</span>
          <span class="font-weight-regular">R$ {{ Helpers.formatarValorComCasas(produtos.reduce((a, b) => a + Number(b.total_ruptura), 0), 2) }}</span>
        </div>
      </div>
    </template>

    <div class="pl-2 pr-1">
      <sys-data-table
        :headers="headers"
        :height="alturaDaJanela - 160"
        item-height="45"
        :items="produtos"
        :search="pesquisa"
        :item-class="item => ({
          'text-red': item.fora_de_linha === 'SIM',
          'text-orange': item.ativo_para_venda === 'NAO',
        })"
      >
        <template #top>
          <div class="d-flex align-center py-3 pr-1 w-full">
            <v-icon size="22" class="mr-1">mdi-format-list-bulleted</v-icon>
            <span class="font-21 font-weight-medium text-systock-blue">Produtos</span>

            <v-divider vertical class="mx-3" />

            <SysBtn @click="exportar()">
              <v-icon left>$Excel</v-icon>
              Exportar
            </SysBtn>

            <v-spacer />

            <div class="w-450">
              <v-text-field
                v-model="pesquisa"
                hide-details
                dense clearable
                label="Pesquisar"
                append-icon="mdi-magnify"
                v-lazy-input:debounce="1000"
              />
            </div>
          </div>
        </template>

        <template #item.descricao_segmento="{ item }">
          {{ `${item.idsegmento} - ${item.descricao_segmento}` }}
        </template>

        <template #item.descricao_fornecedor="{ item }">
          {{ `${item.idfornecedor} - ${item.descricao_fornecedor}` }}
        </template>

        <template #item.descricao_produto="{ item }">
          <div class="d-flex align-center">
            <DetalhesProduto
              :produto="{ id_grupo: item.id_grupo, id_filial: item.filial, id_produto: item.idproduto, produto_eh_combinacao: item.produto_eh_combinacao}"
              ativar_filtro_revenda_direta
            />
            {{ `${item.idproduto} - ${item.descricao_produto}` }}
          </div>
        </template>

        <template #item.qtde_dias_ruptura="{ item }">
          <DetalhamentoQtdeDiasRuptura
            :id_grupo="Number(item.id_grupo)"
            :filial="Number(item.filial)"
            :idproduto="String(item.idproduto)"
            :descricao_produto="String(item.descricao_produto)"
            :produto_eh_combinacao="item.produto_eh_combinacao"
            :qtde_dias_ruptura="item.qtde_dias_ruptura"
            :ano="Number(filtros.ano)"
            :mes="Number(filtros.mes)"
          />
        </template>

        <template #item.qtde_dias_diferenca="{ value }">
          <span
            v-if="value"
            :style="{color: value >= 0 ? 'green' : 'red'}"
            :title="`A última solicitação de compra foi feita ${value >= 0 ? 'antes' : 'após'} da ruptura.`"
          >
            {{ Math.abs(value) }}
          </span>
        </template>

        <template #item.total_ruptura="{ item }">
          <div class="d-flex align-center">
            <span class="text-no-wrap">
              R$ {{ Helpers.formatarValorComCasas(item.total_ruptura, 2) }}
            </span>

            <Legenda v-if="item.fora_de_linha === 'SIM'" titulo="Fora de linha" legenda="Produto cadastrado como fora de linha">
              <v-icon color="red" class="ml-1">mdi-alert</v-icon>
            </Legenda>

            <Legenda v-else-if="item.ativo_para_venda === 'NAO'" titulo="Inativo para venda" legenda="Produto cadastrado como inativo para venda">
              <v-icon color="orange" class="ml-1">mdi-cart-remove</v-icon>
            </Legenda>
          </div>
        </template>

        <template #footer="{countItems}">
          <div class="d-flex align-center w-full font-12 py-2 px-3">
            <v-spacer />

            <v-icon :size="20" color="orange">mdi-cart-remove</v-icon>
            <span class="ml-1">Produto inativo para venda</span>

            <v-divider vertical class="mx-3" />

            <v-icon :size="20" color="error">mdi-alert</v-icon>
            <span class="ml-1">Produto Fora de Linha</span>

            <v-divider vertical class="mx-3" />

            <span>Itens carregados: {{Helpers.formatarValor(countItems)}}</span>
          </div>
        </template>
      </sys-data-table>
    </div>
  </SysDialogFullscreen>
</template>

<script>
import ResponsiveHeight from "@/helpers/ResponsiveHeight.js";
import SysDialogFullscreen from "@/components/padraoDeLayout/SysDialogFullScreen.vue";
import api from "@/api/api";
import {formatarParametrosObjParaUrl, logout, nomeMeses} from "@/helpers";
import DetalhesProduto from "@/components/produto/detalhes/Index.vue";
import Legenda from "@/components/produto/detalhes/Legenda.vue";
import $axios from "@/api/api";
import DetalhamentoQtdeDiasRuptura
  from "@/components/indicadores/PerdaVendaPorRupturas/Grid/DetalhamentoQtdeDiasRuptura.vue";

export default {
  name: 'DetalhamentoClickGrid',
  mixins: [ResponsiveHeight],
  components: {
    DetalhamentoQtdeDiasRuptura,
    Legenda,
    DetalhesProduto,
    SysDialogFullscreen,
  },
  model: {
    prop: 'modelValue',
    event: 'update:modelValue',
  },
  props: {
    modelValue: Boolean,
    filtros: {
      type: Object,
      default: () => ({})
    }
  },
  emits: ['update:modelValue'],
  data: () => ({
    pesquisa: '',
    headers: [
      { text: "Tipo Ruptura", value: "tipo_ruptura" },
      { text: "Estoque Grupo no dia da Ruptura", value: "estoque_grupo_dia_ult_saida", is_number: true },
      { text: "Filial", value: "filial" },
      { text: "Departamento", value: "descricao_segmento" },
      { text: "Descrição Fornecedor", value: "descricao_fornecedor" },
      { text: "Descrição Produto", value: "descricao_produto" },
      { text: "Qtde. Dias Ruptura", value: "qtde_dias_ruptura" },
      { text: "Última Solicitação de Compra", value: "data_ultima_compra" },
      { text: "Última Venda", value: "data_ultima_venda" },
      { text: "Qtde. dias da Última Solicitação até a Ruptura", value: "qtde_dias_diferenca", is_number: true },
      { text: "UM", value: "idunidade_medida" },
      { text: "Compra em Trânsito", value: "estoque_transito", is_number: true },
      { text: "Projeção de Vendas", value: "projecao_vendas", is_number: true },
      { text: "Preço Médio Venda", value: "preco_medio_venda", is_money: true },
      { text: "Valor Diário Venda", value: "venda_diaria_calc", is_money: true },
      { text: "Total Ruptura", value: "total_ruptura", is_money: true },
    ],
    produtos: [],
    map_niveis_servico: {
      'NIVEL ELEVADO': '0. Nível Elevado',
      'NIVEL ALTO': '1. Nível Alto',
      'NIVEL MEDIO': '2. Nível Médio',
      'NIVEL BAIXO': '3. Nível Baixo',
      'NIVEL ORDINARIO': '4. Nível Ordinário',
      'SOB ENCOMENDA': '5. Sob Encomenda',
    }
  }),
  computed: {
    DIALOG_ATIVO_COMPUTED: {
      get: function () {
        return this.modelValue;
      },
      set: function (valor) {
        return this.$emit('update:modelValue', valor);
      }
    }
  },
  watch: {
    DIALOG_ATIVO_COMPUTED() {
      if (this.DIALOG_ATIVO_COMPUTED) {
        this.buscarProdutos();
      } else {
        this.produtos = [];
      }
    }
  },
  methods: {
    nomeMeses(index) {
      return nomeMeses[index] ? nomeMeses[index] : '';
    },
    buscarProdutos() {
      api.post('indicadores/perda-venda-por-ruptura/detalhamento', this.filtros)
        .then(response => {
          this.produtos = response.data.produtos;
        })
        .catch(logout)
    },
    exportar() {
      const url = $axios.defaults.baseURL
          + '/indicador_perda_venda_ruptura'
          + formatarParametrosObjParaUrl({
            ...this.filtros,
            fora_de_linha: this.filtros.fora_de_linha ? 'S' : 'N',
            inativo_revenda: this.filtros.inativo_revenda ? 'S' : 'N',
            id_usuario: localStorage.getItem("id")
          });

      window.open(url, "_blank");
    }
  }
}
</script>
